import img1 from "../../../../assets/images/industries/img1.svg";
import img2 from "../../../../assets/images/industries/img2.svg";
import img3 from "../../../../assets/images/industries/img3.svg";
import img4 from "../../../../assets/images/industries/img4.svg";
import img5 from "../../../../assets/images/industries/img5.svg";
import img6 from "../../../../assets/images/industries/img6.svg";
import img7 from "../../../../assets/images/industries/img7.svg";
import img8 from "../../../../assets/images/industries/img8.svg";
import img9 from "../../../../assets/images/industries/img9.svg";
import img10 from "../../../../assets/images/industries/img10.svg";

export default [
  {
    img: img1,
  },
  {
    img: img2,
  },
  {
    img: img3,
  },
  {
    img: img4,
  },
  {
    img: img5,
  },
  {
    img: img6,
  },
  {
    img: img7,
  },
  {
    img: img8,
  },
  {
    img: img9,
  },
  {
    img: img10,
  },
];
